import { Box } from '@mui/system';
import React from 'react';
import { status, statusColors } from './followupUtil';

interface IProps {
  status:
    | 'PENDING'
    | 'APPROVED'
    | 'APPROVEDBYMANAGER'
    | 'DISAPPROVED'
    | 'DISAPPROVEDBYMANAGER'
    | 'ARCHIVED'
    | 'ARCHIVEDBYMANAGER';
}

const FollowupStatus = (props: IProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '15px', height: '15px', borderRadius: '50%', backgroundColor: statusColors[props.status] }} />
      <Box sx={{ marginLeft: 1 }}> {status[props.status]}</Box>
    </Box>
  );
};

export default FollowupStatus;
